import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { UserRound, Mail, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCustomer } from "@/lib/customer";

export default function RegistrationGate({ contest, onIdentified }) {
  const navigate = useNavigate();
  const { customer } = useCustomer();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const regUrl = `${window.location.origin}/accedi?next=${encodeURIComponent(`/gioca/${contest.id}`)}`;
  const check = async () => {
    if (!/\S+@\S+\.\S+/.test(email)) return toast.error("Inserisci un'email valida");
    setBusy(true);
    try {
      const r = await api.customerLookup(email.trim());
      toast.success(`Bentornato${r.name ? `, ${r.name}` : ""}!`);
      onIdentified(email.trim().toLowerCase());
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Email non registrata");
    } finally {
      setBusy(false);
    }
  };
  if (customer) return null;
  return (
    <>
      <div className="w-full max-w-lg mx-auto rounded-3xl bg-white/95 text-slate-900 p-6 sm:p-8 space-y-5 shadow-2xl" data-testid="registration-gate">
        <div className="text-center">
          <UserRound className="h-10 w-10 mx-auto text-emerald-600" />
          <h2 className="font-display font-bold text-2xl mt-2">Registrati per giocare</h2>
          <p className="text-sm text-slate-500">Questo concorso richiede la registrazione gratuita.</p>
        </div>
        <div className="grid sm:grid-cols-2 gap-5 items-center">
          <div className="text-center space-y-2">
            <div className="inline-block rounded-xl bg-white p-2 border border-slate-200"><QRCodeSVG value={regUrl} size={150} data-testid="registration-qr" /></div>
            <p className="text-xs text-slate-500 flex items-center justify-center gap-1"><Smartphone className="h-3.5 w-3.5" /> Inquadra e registrati dal tuo telefono</p>
          </div>
          <div className="space-y-3">
            <p className="text-xs font-semibold text-slate-600">Già registrato? Inserisci la tua email</p>
            <Input data-testid="gate-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && check()} placeholder="nome@esempio.it" className="bg-slate-100 border-slate-200 text-slate-900 h-12" />
            <Button data-testid="gate-email-button" onClick={check} disabled={busy} className="w-full h-12 gap-2 bg-emerald-600 hover:bg-emerald-700"><Mail className="h-4 w-4" /> Continua</Button>
            <Button data-testid="gate-login-button" variant="outline" onClick={() => navigate(`/accedi?next=${encodeURIComponent(`/gioca/${contest.id}`)}`)} className="w-full h-10 text-xs border-slate-300 text-slate-700">Registrati qui sul totem</Button>
          </div>
        </div>
      </div>
    </>
  );
}
